import { createConsola, type ConsolaInstance, type LogObject } from 'consola'

const logLevelConfig = 'YM_LOG_LEVEL'
const logLevelDefault = process.env[logLevelConfig] ? parseInt(process.env[logLevelConfig]) : 3 // info by default

let instance: ConsolaInstance|null = null
export const createLogger = (category: string): ConsolaInstance => {
  if (!instance) {
    instance = createConsola({
      formatOptions: {
        date: true,
        colors: false,
        compact: false
      },
      throttleMin: 50,
      reporters: [
        {
          log: (logObj: LogObject) => {
            let msg = `${logObj.date.toISOString()} | ${(logObj.type || '').toUpperCase().padEnd(8, ' ')} | ${(logObj.tag || '').padEnd(20, ' ')} | `
            const args: any[] = Array.isArray(logObj.args) ? logObj.args : []
            if (args.length > 0 && typeof args[0] === 'string') {
              msg += args.shift()
            }
            ((console as any)[`__${logObj.type}`] || (console as any)[logObj.type] || console.log)(msg, ...args)
          }
        }
      ],
      level: 5 // our root consola can do all levels; sub-instances are set to lower levels most of the time
    })
  }

  // Construct logger with optional level override
  const logger = instance.withTag(category)
  if (category) {
    const levelCategory = `${logLevelConfig}_${category.replace(/^ym:/, '').replace(/:/g, '_')}`.toUpperCase()
    const level = process.env[levelCategory] ? parseInt(process.env[levelCategory]) : 0
    if (level > 0) {
      logger.level = level
    } else {
      logger.level = logLevelDefault
    }
  }
  return logger
}

const loggedSites = new Set<string>()

export function logOncePerCallSite(message: string) {
  const stack = new Error('nope').stack
  if (!stack) { return }

  const lines = stack.split('\n')

  // The fourth line usually contains the caller information (depends on TS/JS engine)
  const callSiteLine = lines[3] || ''

  // Extract file path and line number
  const match = callSiteLine.match(/\(?(.+):(\d+):\d+\)?$/)
  if (!match) { return }

  const [, file, line] = match
  const key = `${file}:${line}`

  if (!loggedSites.has(key)) {
    loggedSites.add(key)
    console.log(`[${key}] ${message}`)
  }
}
